/** LISTCTR-2 · 手机站预览台用的接口（后端 routes/site_admin.py，SITE-H1 / LISTCTR-2）。 */
import { api } from "./api";

export interface SiteBanner {
  id?: string;
  sort_order?: number;
  image_url: string;
  product_id: string;
  product_code?: string | null;
  product_title?: string | null;
  active: boolean;
  /** 前台现在会不会出：启用 + 跳转线路在手机站展示 */
  showing?: boolean;
  reason_label?: string | null;
}
export interface SiteBanners { max: number; items: SiteBanner[] }

export interface SiteFeaturedItem {
  product_id: string;
  product_code: string | null;
  product_title: string | null;
  showing: boolean;
  reason_label: string | null;
}

export interface SiteProductStatus {
  product_id: string;
  code: string;
  title: string;
  /** PPR-3 · 对客标题（空 = 用产品名） */
  public_title?: string | null;
  showing: boolean;
  reason: "unpublished" | "off_shelf" | "no_image" | "no_price" | null;
  reason_label: string | null;
  /** ENNAME-3 · 英文版在不在展示（中文版在展示 + 有真英文名）；缺英文名时 en_label =「英文版不显示（缺英文名）」 */
  en_showing?: boolean;
  en_label?: string | null;
}
export interface SiteProductsStatus { showing: number; total: number; items: SiteProductStatus[]; en_showing?: number }

export interface PreviewToken { token: string; expires_at: string; expires_in: number; path: string }

/** SITECAT-1 · 首页分类（后台可配）：每个分类含线路清单 + 「在手机站展示」标记 */
export interface SiteCategoryProduct { product_id: string; title: string | null; code: string | null; showing: boolean; reason_label?: string | null }
export interface SiteCategory {
  id: string;
  name_cn: string;
  name_en: string | null;
  icon: string;
  active: boolean;
  sort_order: number;
  products: SiteCategoryProduct[];
  showing_count: number;
}
export interface SiteCategories { max: number; icons: string[]; items: SiteCategory[] }
export interface SiteCategoryIn { id?: string; name_cn: string; name_en: string | null; icon: string; active: boolean; product_ids: string[] }

export const SITE_QK = {
  categories: ["site", "categories"] as const,
  banners: ["site", "banners"] as const,
  featured: ["site", "featured"] as const,
  status: ["site", "products-status"] as const,
  token: ["site", "preview-token"] as const,
};

export const getSiteBanners = (): Promise<SiteBanners> => api("/api/v1/site/banners");
export const putSiteBanners = (items: { image_url: string; product_id: string; active: boolean }[]): Promise<SiteBanners> =>
  api("/api/v1/site/banners", { method: "PUT", body: JSON.stringify({ items }) });
export const getSiteCategories = (): Promise<SiteCategories> => api("/api/v1/site/categories");
export const putSiteCategories = (items: SiteCategoryIn[]): Promise<SiteCategories> =>
  api("/api/v1/site/categories", { method: "PUT", body: JSON.stringify({ items }) });
export const getSiteFeatured = (): Promise<{ items: SiteFeaturedItem[] }> => api("/api/v1/site/featured");
export const putSiteFeatured = (productIds: string[]): Promise<{ items: SiteFeaturedItem[] }> =>
  api("/api/v1/site/featured", { method: "PUT", body: JSON.stringify({ product_ids: productIds }) });
export const getSiteProductsStatus = (): Promise<SiteProductsStatus> => api("/api/v1/site/products-status");
/** 签发手机站预览令牌（2 小时有效）；只有登录后台且有「上架中心 · 查看」的人签发得出来 */
export const createSitePreviewToken = (): Promise<PreviewToken> => api("/api/v1/site/preview-token", { method: "POST" });
